const stripeEntities = [
    "balance_transactions",
    "charges",
    "checkout_sessions",
    "credit_notes",
    "customers",
    "disputes",
    "events",
    "invoice_items",
    "invoices",
    "payment_intents",
    "payouts",
    "prices",
    "products",
    "refunds",
    "subscriptions",
];
export const STRIPE_ENTITY_FACTS = {
    supported: stripeEntities,
    defaults: stripeEntities,
};
const sharePointEntities = ["documents"];
export const SHAREPOINT_ENTITY_FACTS = {
    supported: sharePointEntities,
    defaults: sharePointEntities,
};
const hubSpotEntities = [
    "contacts",
    "companies",
    "deals",
    "owners",
    "pipelines",
    "engagements",
];
export const HUBSPOT_ENTITY_FACTS = {
    supported: hubSpotEntities,
    defaults: hubSpotEntities,
};
const sunEntities = [
    "account",
    "analysis_code",
    "analysis_dimension",
    "analysis_structure_setup",
    "balance",
    "business_unit",
    "currency_rate_type",
    "customer",
    "document_format_setup",
    "financial_reports_column_heading",
    "journal",
    "journal_preset",
    "journal_type",
    "ledger_revaluation_profile",
    "ledger_setup",
    "payment_profile",
    "payment_terms_group",
    "period",
    "purchase_business_setup",
    "purchase_invoice",
    "purchase_type",
    "reconciliation_accounts_setup",
    "reconciliation_profile",
    "sales_invoice",
    "sales_type",
    "supplier",
    "tax_detail",
    "transaction_reference_setup",
];
export const SUN_ENTITY_FACTS = {
    supported: sunEntities,
    defaults: sunEntities,
};
const xeroEntities = [
    "accounts",
    "contacts",
    "invoices",
    "credit_notes",
    "payments",
    "purchase_orders",
    "repeating_invoices",
    "quotes",
    "bank_transactions",
    "tracking_categories",
    "tax_rates",
    "journals",
    "manual_journals",
    "budgets",
    "attachments",
    "contact_history",
];
export const XERO_ENTITY_FACTS = {
    supported: xeroEntities,
    defaults: xeroEntities,
};
const overtureEntities = [
    "booking-list-items",
    "bookings",
    "calendar_events",
    "documents",
    "event_bookings",
    "groups",
    "notes",
    "people",
    "team_roles",
    "companies",
    "tasks",
    "riders",
    "contract_clauses",
    "statuses",
    "tags",
];
export const OVERTURE_DOCUMENT_EXTRACTION_ENTITY = "document-extractions";
export const OVERTURE_ENTITY_FACTS = {
    supported: [...overtureEntities, OVERTURE_DOCUMENT_EXTRACTION_ENTITY],
    // Booking details share a list step; extraction is explicitly requested or enabled.
    defaults: overtureEntities.filter(entity => entity !== "bookings"),
};
const goCardlessEntities = [
    "account_details",
    "accounts",
    "balances",
    "requisitions",
    "transactions",
];
export const GOCARDLESS_ENTITY_FACTS = {
    supported: goCardlessEntities,
    defaults: goCardlessEntities,
};
// Repository jobs; legacy notifications are not selectable by the job planner.
const githubEntities = ["repository", "branch", "commit", "pull_request"];
export const GITHUB_REPOSITORY_ENTITY_FACTS = {
    supported: githubEntities,
    defaults: githubEntities,
};
const granolaEntities = ["note"];
export const GRANOLA_ENTITY_FACTS = {
    supported: granolaEntities,
    defaults: granolaEntities,
};
const outlookMailEntities = ["message"];
export const OUTLOOK_MAIL_ENTITY_FACTS = {
    supported: outlookMailEntities,
    defaults: outlookMailEntities,
};
const gmailEntities = ["message"];
export const GMAIL_ENTITY_FACTS = {
    supported: gmailEntities,
    defaults: gmailEntities,
};
const googleCalendarEntities = ["event"];
export const GOOGLE_CALENDAR_ENTITY_FACTS = {
    supported: googleCalendarEntities,
    defaults: googleCalendarEntities,
};
const googleDriveEntities = ["file"];
export const GOOGLE_DRIVE_ENTITY_FACTS = {
    supported: googleDriveEntities,
    defaults: googleDriveEntities,
};
const googleSheetsEntities = ["sheet_row"];
export const GOOGLE_SHEETS_ENTITY_FACTS = {
    supported: googleSheetsEntities,
    defaults: googleSheetsEntities,
};
const slackEntities = ["mention", "direct_message"];
export const SLACK_ENTITY_FACTS = {
    supported: slackEntities,
    defaults: slackEntities,
};
export const TWIN_IDENTITY_LINK_ENTITY = "identity_link";
const twinEntities = [TWIN_IDENTITY_LINK_ENTITY];
export const TWIN_ENTITY_FACTS = {
    supported: twinEntities,
    defaults: twinEntities,
};
const asanaEntities = ["metadata", "tasks", "workspaces", "projects", "users", "teams", "stories"];
export const ASANA_ENTITY_FACTS = {
    supported: asanaEntities,
    defaults: asanaEntities,
};
